import * as request from "@/utils/request";

export default {
	// 行业列表
	getDailyTaskIndustryList(data) {
		return request.post("/daily_task/industry_list", data);
	},

	// 岗位标签
	getDailyPostTagList(data) {
		return request.post("/daily_task/recruit_post_tag", data);
	},
	// 岗位列表
	getDailyPostList(data) {
		return request.post("/daily_post/list", data);
	},
	// 岗位详情
	getDailyPostInfo(data) {
		return request.post("/daily_post/view", data);
	},
	// 创建岗位
	createDailyPost(data) {
		return request.post("/daily_post/create", data);
	},
	updateDailyPost(data) {
		return request.post("/daily_post/update", data);
	},
	// 删除岗位
	deleteDailyPost(data) {
		return request.post("/daily_post/delete", data);
	},

	// 公域任务列表
	getDailyTaskList(data) {
		return request.post("/daily_task/list", data);
	},
	// 公域任务发布
	createDailyTask(data) {
		return request.post("/daily_task/create", data);
	},
	// 公域任务删除
	deleteDailyTaskList(data) {
		return request.post("/daily_task/list", data);
	},
	// 公域任务关闭
	closeDailyTask(data) {
		return request.post("/daily_task/close", data);
	},
	// 公域任务 交付审核列表
	getDaily_deliver_list(data) {
		return request.post("/daily_task/deliver_list", data);
	},
	//公域任务 报名记录
	getDaily_taskJoin_list(data) {
		return request.post("/daily_task/join_list", data);
	},
	//私域任务 报名记录
	getDaily_PrivateTaskJoin_list(data) {
		return request.post("/mission/task_index", data);
	},
	// 公域任务 交付审核 列表
	getDaily_taskDeliver_audit(data) {
		return request.post("/daily_task/deliver_audit", data);
	},
	// 公域任务 交付详情
	getDaily_taskDeliver_view(data) {
		return request.post("/daily_task/deliver_view", data);
	},
	/*
	 ***********************************公域任务*************************************
	 */
	// 公域任务 报名审核
	postDaily_deliver_signup_audit(data) {
		return request.post("/daily_task/audit", data);
	},
	// 私域任务 报名审核
	postDaily_private_signup_audit(data) {
		return request.post("/mission/task_audit", data);
	},
	// 公域任务 任务交付记录
	post_task_privatejoinList(data) {
		return request.post("/daily_task/join_list", data);
	},
	// 公域任务 公域任务交付审核
	post_task_privatejoinAudit(data) {
		return request.post(`/daily_task/deliver_audit`, data);
	},
	// 公域任务 公域任务交付编辑
	post_task_privatejoinUpdate(data) {
		return request.post(`/daily_task/deliver_update`, data);
	},
	// 公域任务 公域任务交付详情
	post_task_privatejoinInfo(data) {
		return request.post(`/daily_task/deliver_view`, data);
	},
	/*
	 ***********************************私域任务*************************************
	 */
	// 私域任务 任务交付记录
	post_deliver_privatejoinList(data) {
		return request.post("/mission/join/list", data);
	},
	// 私域任务 任务交付审核
	post_deliver_privatejoinExamine(id, data) {
		return request.post(`/mission/join/examine/${id}`, data);
	},
	// 私域任务 任务交付编辑
	post_deliver_privatejoinUpdate(id, data) {
		return request.post(`/mission/join/update/${id}`, data);
	},
	// 私域任务 任务交付详情
	post_deliver_privatejoinInfo(id) {
		return request.post(`/mission/join/info/${id}`);
	},
	// 私域任务交付批量审核
	post_deliver_privatejoinAllExamine(data) {
		return request.post(`/mission/join/all_examine`, data);
	},
	// 私域任务交付批量审核
	post_deliver_privatejoinAutoExamine(id, data) {
		return request.post(`/mission/join/auto_examine/deliver/${id}`, data);
	},


		/*
	 ***********************************安心登记卡*************************************
	 */
	// 获取二维码
	get_anxinCode_qrcode(data) {
		return request.get(`/industryOfflinelabor/qrcode`, data);
	},
	// 获取人员列表
	get_anxinCode_personalList(data) {
		return request.get(`/industryOfflinelabor/list`, data);
	},

	// 快速发布-岗位列表
	get_quick_recruit_post_list(data) {
		return request.post(`/daily_post/quick_recruit_post_list`, data);
	},
	// 快速发布-任务列表
	get_quick_mission_list(data) {
		return request.post(`/daily_post/quick_mission_list`, data);
	},

	// 招聘管理登录
	recruitLogin(data){
		return request.get(`/quyuhua/login `, data);
	}
};
